import { render, staticRenderFns } from "./fullStats.vue?vue&type=template&id=4ed7fb50&scoped=true"
import script from "./fullStats.vue?vue&type=script&lang=js"
export * from "./fullStats.vue?vue&type=script&lang=js"
import style0 from "./fullStats.vue?vue&type=style&index=0&id=4ed7fb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7fb50",
  null
  
)

export default component.exports